// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		paginationType: bcSfFilterConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' :
			(bcSfFilterConfig.custom.pagination_type == 'load_more' ? 'load_more' : 'default'),
	},
	template: {
		loadMoreLoading: '<div id="bc-sf-filter-load-more-loading"><div class="load-more__icon" style="width: 44px; height: 44px; opacity: 1;"></div></div>',
	}
};

// Declare Templates
var bcSfFilterTemplate = {
  'saleLabelHtml': '<div class="sale_banner thumbnail_banner">' + bcSfFilterConfig.label.sale + '</div>',
  'newLabelHtml': '<div class="new_banner thumbnail_banner">' + bcSfFilterConfig.label.new + '</div>',
  'preorderLabelHtml': '<div class="new_banner thumbnail_banner">' + bcSfFilterConfig.label.pre_order + '</div>',
  'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery">&#x002B;</span>',
  'newRowHtml': '<br class="clear product_clear" />',

  // Grid Template
  'productGridItemHtml': 	'<div class="{{flipImageClass}} {{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupSmallClass}} quick-shop-style--'+ bcSfFilterConfig.custom.quick_shop_style +' product-{{itemId}}" data-boost-theme-quickview="{{itemId}}">' +
								'<div class="product-wrap">' +
									'<div class="relative product_image swap-' + bcSfFilterConfig.custom.secondary_image + '">' +
										'<a href="{{itemUrl}}">' +
											'{{itemImages}}' +
										'</a>' +
										'{{itemColorSwatchesInline}}' +
										'{{itemProductInfoHover}}' +
										'<div class="banner_holder">' +
											'{{itemSaleLabel}}' +
											'{{itemNewLabel}}' +
											'{{itemPreorderLabel}}' +
										'</div>' +
									'</div>' +
									'<a class="product-info__caption {{itemHiddenClass}}" href="{{itemUrl}}">' +
										'{{itemProductInfo}}' +
									'</a>' +
								'</div>' +
								'{{itemColorSwatchesPopup}}' +
							'</div>',


  // Pagination Template
  'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + bcSfFilterConfig.label.paginate_prev + '</a></span>',
  'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.paginate_next + ' »</a></span>',
  'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
  'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
  'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
  'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

  // Sorting Template
  'sortingHtml': '{{sortingItems}}',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	var onSaleClass = onSale ? 'sale' : '';
	var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';
	var availabilityProp = soldOut ? 'http://schema.org/SoldOut' : 'http://schema.org/InStock';

	// Add custom class
	var itemColumnNumberClass = '';
	var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, bcSfFilterConfig.custom.products_per_row);
	var itemCollectionGroupLargeClass = '';
	var itemCollectionGroupMediumClass = '';
	var itemCollectionGroupSmallClass = (index - 1) % 2 == 0 ? 'even' : 'odd';

	switch (bcSfFilterConfig.custom.products_per_row) {
		case 2:
			itemColumnNumberClass = 'eight columns';
			break;
		case 3:
			itemColumnNumberClass = 'one-third column';
			break;
		case 4:
			itemColumnNumberClass = 'four columns';
			break;
		case 5:
			itemColumnNumberClass = 'one-fifth column';
			break;
		case 6:
			itemColumnNumberClass = 'one-sixth column';
			break;
		default:
			itemColumnNumberClass = 'one-seventh column';
			break;
	}

	if (bcSfFilterConfig.custom.mobile_products_per_row == 1) {
		itemColumnNumberClass += ' medium-down--one-half small-down--one-whole';
	} else {
		itemColumnNumberClass += ' medium-down--one-half small-down--one-half';
	}

	itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupLargeClass}}/g, itemCollectionGroupLargeClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupMediumClass}}/g, itemCollectionGroupMediumClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupSmallClass}}/g, itemCollectionGroupSmallClass);

	// Add soldOut label
	var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

	// Add onSale label
	var itemSaleLabel = bcSfFilterConfig.custom.sale_banner_enabled && onSale ? bcSfFilterTemplate.saleLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

	// Add Label (New, Coming soon, Pre order)
	var newLabel = data.collections.filter(function (e) {
		return e.handle == 'new';
	});
	var preorderLabel = data.collections.filter(function (e) {
		return e.handle == 'pre-order';
	});
	var comingsoonLabel = data.collections.filter(function (e) {
		return e.handle == 'coming-soon';
	});
	if (data.collections) {
		var itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? bcSfFilterTemplate.newLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);

		var itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? bcSfFilterTemplate.comingsoonLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);

		var itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? bcSfFilterTemplate.preorderLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);
	}

	var itemHiddenClass = bcSfFilterConfig.custom.thumbnail_hover_enabled ? 'hidden' : '';
	itemHtml = itemHtml.replace(/{{itemHiddenClass}}/g, itemHiddenClass);

	var flipImageClass = bcSfFilterConfig.custom.secondary_image && images.length > 1 ? 'has-secondary-media-swap' : '';
    itemHtml = itemHtml.replace(/{{flipImageClass}}/ , flipImageClass)
	// Get image source
	var itemImageSrc = 'data-src="' + this.getFeaturedImage(images, '900x') + '" ';
	itemImageSrc += 'data-srcset=" ' + this.getFeaturedImage(images, '300x') + ' 300w,';
	itemImageSrc += this.getFeaturedImage(images, '400x') + ' 400w, ';
	itemImageSrc += this.getFeaturedImage(images, '500x') + ' 500w, ';
	itemImageSrc += this.getFeaturedImage(images, '600x') + ' 600w, ';
	itemImageSrc += this.getFeaturedImage(images, '700x') + ' 700w, ';
	itemImageSrc += this.getFeaturedImage(images, '800x') + ' 800w, ';
	itemImageSrc += this.getFeaturedImage(images, '900x') + ' 900w" ';
	// Get Thumbnail url
	var itemThumbUrl = this.getFeaturedImage(images, bcSfFilterConfig.custom.image_loading_style == 'blur-up' ? '50x' : '100x');
	// Get Flip image url
	var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src']) : this.getFeaturedImage(images, '900x');
	
	// Add Thumbnail
	var product_set_width = data.featured_image.width;
	var align_height_value = '';
	if (bcSfFilterConfig.custom.align_height) {
		if (images.length > 0) {
			var collection_height = bcSfFilterConfig.custom.collection_height;
			var product_aspect_ratio = images[0]['width'] / images[0]['height'];
			product_set_width = product_aspect_ratio * collection_height;
			if (images[0]['width'] >= images[0]['height']) {
				align_height_value = 'width: 100%; height: auto;';
			} else {
				align_height_value = 'width: 100%;';
			}
		}
	}
	var backgroundColor = '';
	if (bcSfFilterConfig.custom.image_loading_style == 'color') {
		var dominantColorImage = this.getFeaturedImage(images, '1x');
		backgroundColor = 'background: url(' + dominantColorImage + ')';
	}
	var itemImagesHtml = '<div class="image__container">';
	itemImagesHtml += '<div class="image-element__wrap" style="width: ' + product_set_width + 'px; ' + backgroundColor + '">';
	itemImagesHtml += '<img src="' + itemThumbUrl + '"' +
						' alt="{{itemTitle}}" ' +
						' class="lazyload transition--' + bcSfFilterConfig.custom.image_loading_style + '"' +
						' style="' + align_height_value + 'max-width: ' + data.featured_image.width + 'px;"' +
						' data-sizes="auto" ' + itemImageSrc + '/>';
	itemImagesHtml += '</div>';
	itemImagesHtml += '</div>';
	// Add Flip Image
	if (bcSfFilterConfig.custom.secondary_image && images.length > 1) {
      	// Get image source      
		var itemFlipImageSrc = 'data-src="' + this.optimizeImage(images[1]['src'], '900x') + '" ';
		itemFlipImageSrc += 'data-srcset=" ' + this.optimizeImage(images[1]['src'], '300x')  + ' 300w, ';
		itemFlipImageSrc += this.optimizeImage(images[1]['src'], '400x')  + ' 400w, ';
		itemFlipImageSrc += this.optimizeImage(images[1]['src'], '500x')  + ' 500w, ';
		itemFlipImageSrc += this.optimizeImage(images[1]['src'], '600x')  + ' 600w, ';
		itemFlipImageSrc += this.optimizeImage(images[1]['src'], '700x')  + ' 700w, ';
		itemFlipImageSrc += this.optimizeImage(images[1]['src'], '800x')  + ' 800w, ';
		itemFlipImageSrc += this.optimizeImage(images[1]['src'], '900x')  + ' 900w" ';
			itemImagesHtml += '<div class="image__container">';
			itemImagesHtml += '<div class="image-element__wrap" style="width:';
			if (images.length > 1) {
				itemImagesHtml += images[1]['width'] + 'px">';
			} else {
				itemImagesHtml += data.featured_image.width + 'px">';
			}
			itemImagesHtml += '<img src="' + itemFlipImageUrl + '" ';
			itemImagesHtml += 'class="lazyload transition--blur-up secondary lazypreload lazyautosizes secondary-media-hidden" alt="{{itemTitle}}" data-sizes="auto" ' + itemFlipImageSrc + '/>'
			itemImagesHtml += '</div>';
			itemImagesHtml += '</div>';
	}
  
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Build Product Info when hovering 
	var itemProductInfoHoverHtml = '';
	if ((bcSfFilterConfig.custom.thumbnail_hover_enabled || bcSfFilterConfig.custom.quick_shop_enabled) && bcSfFilterConfig.custom.quick_shop_style == 'popup') {
		itemProductInfoHoverHtml = '<div class="thumbnail-overlay">' +
			'<a href="{{itemUrl}}" class="hidden-product-link">{{itemTitle}}</a>' +
			'<div class="info">' +
			(bcSfFilterConfig.custom.thumbnail_hover_enabled ? '{{itemProductInfo}}' : '') +
			'</div>' +
			'</div>';
	}
	itemHtml = itemHtml.replace(/{{itemProductInfoHover}}/g, itemProductInfoHoverHtml);

	// Build Product Info (product-info.liquid)
	var itemProductInfoHtml = '<div class="product-details">';
	itemProductInfoHtml += '<span class="title">{{itemTitle}}</span>';
	itemProductInfoHtml += '{{itemVendor}}';
	itemProductInfoHtml += '{{itemReview}}';
	itemProductInfoHtml += '{{itemPrice}}';
	itemProductInfoHtml += '</div>';
	itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, itemProductInfoHtml);

	// Add Review badge
	var itemReviewHtml = '';
	if (bcSfFilterConfig.custom.enable_shopify_review_comments && bcSfFilterConfig.custom.enable_shopify_collection_badges) {
		itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
	}
	itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

	// Add Vendor
	var itemVendorHtml = '';
	if (bcSfFilterConfig.custom.vendor_enable) {
		itemVendorHtml = '<span class="brand">' + data.vendor + '</span>';
	}
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add Price
	var itemPriceHtml = '';
	if (typeof comingsoonLabel[0] !== 'undefined') {
		itemPriceHtml += '<span class="modal_price">' + bcSfFilterConfig.label.coming_soon + '</span>';
	} else {
		itemPriceHtml += '<span class="price ' + onSaleClass + '">';
		if (!soldOut) {
			if (priceVaries && data.price_min > 0) {
				itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + '</em></small> ';
			}
			if (data.price_min > 0) {
				itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
			} else {
				itemPriceHtml += bcSfFilterConfig.label.free_price;
			}
		} else {
			itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out + '</span>';
		}
		if (onSale) {
			itemPriceHtml += ' <span class="was_price"><span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span></span>';
		}
		itemPriceHtml += '</span>';
	}
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add Swatches
	var itemColorSwatchesHtml = '';
	if (bcSfFilterConfig.custom.collection_swatches) {
		for (var k in data.options) {
			var option = data['options'][k];
			var downcasedOption = option.toLowerCase();
			var colorTypes = ['color', 'colour', 'farve'];
			if (colorTypes.indexOf(downcasedOption) > -1) {
				var option_index = k;
				var values = [];
				itemColorSwatchesHtml += '<div class="collection_swatches">';
				for (var i in data.variants) {
					var variant = data['variants'][i];
					var value = variant['options'][option_index];
					if (values.indexOf(value) == -1) {
						var values = values.join(',');
						values += ',' + value;
						values = values.split(',');
						var fileColorUrl = bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', this.slugify(value) + '.png');
						fileColorUrl = this.optimizeImage(fileColorUrl, '50x');
						itemColorSwatchesHtml += '<a href="' + this.buildProductItemUrl(data) + '?variant=' + variant.id + '" class="swatch" data-swatch-name="meta-' + downcasedOption + '_' + (value.replace(/\s/g, '_')).toLowerCase() + '">';
						itemColorSwatchesHtml += '<span ';
						if (bcSfFilterConfig.custom.products_per_row == 2) {
							itemColorSwatchesHtml += 'data-image="' + this.optimizeImage(variant.image, '600x') + '" ';
						} else if (bcSfFilterConfig.custom.products_per_row == 2) {
							itemColorSwatchesHtml += 'data-image="' + this.optimizeImage(variant.image, '500x') + '" ';
						} else {
							itemColorSwatchesHtml += 'data-image="' + this.optimizeImage(variant.image, '400x') + '" ';
						}
						itemColorSwatchesHtml += 'style="background-image: url(' + fileColorUrl + '); background-color: ' + this.slugify(value.split(' ').pop()) + ';">';
						itemColorSwatchesHtml += '</span>';
						itemColorSwatchesHtml += '</a>';
					}
				}
				itemColorSwatchesHtml += '</div>';
			}
		}
	}
	if (bcSfFilterConfig.custom.quick_shop_style == 'inline') {
		itemHtml = itemHtml.replace(/{{itemColorSwatchesInline}}/g, itemColorSwatchesHtml);
		itemHtml = itemHtml.replace(/{{itemColorSwatchesPopup}}/g, '');
	} else if (bcSfFilterConfig.custom.quick_shop_style == 'popup' && bcSfFilterConfig.custom.quick_shop_enabled) {
		itemHtml = itemHtml.replace(/{{itemColorSwatchesInline}}/g, '');
		itemHtml = itemHtml.replace(/{{itemColorSwatchesPopup}}/g, itemColorSwatchesHtml);
	} else {
		itemHtml = itemHtml.replace(/{{itemColorSwatchesInline}}/g, '');
		itemHtml = itemHtml.replace(/{{itemColorSwatchesPopup}}/g, '');
	}

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
};

// Build advanced class
function buildItemCollectionGroupThumbClass(index, productsPerRow) {
	var temp = index < productsPerRow ? index : index % productsPerRow;
	if (temp == 0) {
		return 'omega';
	} else if (temp == 1) {
		return 'alpha';
	}
	return '';
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		paginationHtml = jQ.parseHTML(paginationHtml);
		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content 
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			html = jQ.parseHTML(html);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting).val(this.queryParams.sort);
		}
	}
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function () {
	var _this = this;
	jQ(this.selector.topSorting).change(function (e) {
		onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).val());
	})
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
	if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
		var colInfo = colData.collection;

		var breadcrumbHtml = '<span ><a href="' + bcSfFilterConfig.shop.url + '" title="' + bcSfFilterConfig.shop.name + '" class="breadcrumb_link"><span>' + bcSfFilterConfig.label.breadcrumb_home + '</span></a></span> ';
		breadcrumbHtml += '<span class="breadcrumb-divider">/</span> ' +
			'<span><a href="{{currentCollectionLink}}" title="{{currentCollectionTitle}}" class="breadcrumb_link"><span>{{currentCollectionTitle}}</span></a></span> ';
		// Build Tags
		var currentTagsHtml = '';
		if (Array.isArray(bcSfFilterConfig.general.current_tags)) {
			var current_tags = bcSfFilterConfig.general.current_tags;
			for (var k in current_tags) {
				var tag = current_tags[k];
				currentTagsHtml += '<span class="breadcrumb-divider">/</span>';
				currentTagsHtml += '<span><a href="/collections/{{currentCollectionLink}}/' + this.slugify(tag) + '" title="' + tag + '"><span>' + tag + '</span></a></span>';
			}
		}
		breadcrumbHtml += currentTagsHtml;
		// Build Collection Info
		breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
		// Top Pagination
		// var currentPage = parseInt(this.queryParams.page);
		// var totalPage = Math.ceil(apiData.total_product / this.queryParams.limit);
		// var topPaginationHtml = '<span class="breadcrumb-divider">/</span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage)
		breadcrumbHtml += ' <span id="bc-sf-filter-top-pagination"></span>';

		breadcrumbHtml = jQ.parseHTML(breadcrumbHtml);
		jQ('.breadcrumb_text').html(breadcrumbHtml);
	}
};

// Call Theme function to Build additional elements for Product list
BCSfFilter.prototype.buildExtrasProductList = function (data) {
	// Build Quick view data
	if (bcSfFilterConfig.custom.quick_shop_enabled) {
		this.buildExtrasProductListByAjax(data, 'bc-sf-quickview', function(results) {
			results.forEach(function(result) {
				var element = '';
				if (bcSfFilterConfig.custom.quick_shop_style == 'inline') {
					element = jQ('[data-boost-theme-quickview="'+ result.id +'"].thumbnail');
					if (element.find('.js-quick-shop-link').length == 0) {
						element.append(jQ.parseHTML(result.quickview));
					}
				} else {
					element = jQ('[data-boost-theme-quickview="'+ result.id +'"] div.info');
					if (element.find('.js-quick-shop-link').length == 0) {
						element.append(jQ.parseHTML(result.quickview));
					}
				}
			});
			buildTheme();
		});
	}
};

// Build Additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data) {
	var self = this;
	// Remove InstantClick
	jQ(self.getSelector('filterTree')).find('a').attr('data-no-instant', '');

	// Remove product wrapper
	if (jQ(self.getSelector('products')).children().hasClass('product-list')) {
		jQ(self.getSelector('products')).children().children().unwrap();
	}

	// Build top pagination
	var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
	var topPaginationHtml = '<span class="breadcrumb-divider">/</span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage);
	topPaginationHtml = jQ.parseHTML(topPaginationHtml);
	jQ('#bc-sf-filter-top-pagination').html(topPaginationHtml);
	jQ(".load-more__icon").remove();

	buildTheme();
};

function buildTheme() {
	if ((Shopify.theme_settings.enable_shopify_review_comments || Shopify.theme_settings.enable_shopify_collection_badges) && window.SPR) {
		SPR.registerCallbacks();
		SPR.initRatingHandler();
		SPR.initDomEls();
		SPR.loadProducts();
		SPR.loadBadges();
	}
	if (Shopify.theme_settings.show_multiple_currencies) {
		convertCurrencies();
	}
  	imageFunctions.showSecondaryImage()
    if (Shopify.PaymentButton) {
       Shopify.PaymentButton.init();
    }
	productPage.init();
	if (Shopify.theme_settings.quick_shop_enabled) {
		quickShop.init();
	}
	hideNoScript();
}



// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
